import { Component, Inject, TemplateRef, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface TooltipDialogData {
  title?: string;
  content: string;
  template?: TemplateRef<any>;
  data?: any;
  arrowPosition?: 'top' | 'bottom' | 'left' | 'right';
  isFloatingLabelContext?: boolean;
}

@Component({
  selector: 'app-tooltip-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './tooltip-dialog.component.html',
  styleUrl: './tooltip-overlay.scss',
})
export class TooltipDialogComponent {
  isOverlay = false;
  closeTooltip?: () => void;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TooltipDialogData,
  ) {}

  close(): void {
    if (this.closeTooltip) {
      this.closeTooltip();
    }
  }
}
